var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSharp = function SvgSharp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 145.90091",
    height: 145.90091,
    width: 1024,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4362416,0,0,3.4362416,-1078.3312,-2174.3932)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1.5459704,1.5459704,0,415.67057,649.33146)",
    id: "g9277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9279",
    style: {
      fill: "#e6000d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 0,-16.982 -9.878,0 0,-8.776 25.835,0 0,8.776 -10.38,0 0,16.982 10.38,0 0,8.775 -25.835,0 L -9.878,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1.5459704,1.5459704,0,451.89266,657.95179)",
    id: "g9281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9283",
    style: {
      fill: "#e6000d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -10.032,6.111 0,12.035 0,0 m -15.455,2.707 25.835,-15.739 0,6.709 -5.286,3.219 0,18.145 5.286,3.123 0,10.713 -25.835,-15.735 0,-10.435"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1.5459704,1.5459704,0,550.35088,651.36905)",
    id: "g9285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9287",
    style: {
      fill: "#e6000d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -2.738,2.09 -6.749,1.807 -9.046,-2.207 -2.147,-3.74 -2.937,-10.879 -2.937,-15.34 0,-7.136 0.485,-11.73 1.153,-15.638 l 25.469,0 0,8.773 -21.604,0 c -0.626,3.16 -0.64,6.369 -0.584,7.568 0.154,3.483 0.696,5.444 1.807,7.01 1.155,1.619 3.708,2.059 5.48,-0.041 1.321,-1.574 2.359,-4.765 1.27,-11.902 l 1.655,-1.008 11.976,13.494 0,11.947 L 4.259,-9.347 C 3.885,-6.463 2.732,-2.09 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1.5459704,1.5459704,0,346.11736,647.86124)",
    id: "g9289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9291",
    style: {
      fill: "#e6000d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.985,-5.067 -1.597,-9.373 -3.241,-9.373 -1.82,0 -2.289,3.482 -1.766,8.416 0.494,4.666 1.715,9.066 3.461,13.17 L -6.659,15.33 C -7.922,12.013 -9.54,5.177 -9.724,-1.03 c -0.197,-6.8 0.413,-18.281 7.289,-18.777 6.294,-0.453 7.798,8.516 9.166,14.397 1.335,5.736 1.818,11.113 3.804,11.113 1.396,0 2.486,-1.895 2.11,-6.908 C 12.194,-7.239 10.545,-12.373 8,-17.494 l 5.588,-3.403 c 2.22,5.68 4.003,13.129 4.114,19.84 C 17.835,6.922 16.548,15.931 9.714,16.135 4.011,16.302 2.019,10.394 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1.5459704,1.5459704,0,594.18532,651.0413)",
    id: "g9293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9295",
    style: {
      fill: "#e6000d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 1.242,-1.516 1.682,-3.731 1.672,-7.227 -0.009,-2.578 -0.483,-5.246 -0.976,-7.42 l -7.449,0 c -0.626,3.158 -0.635,6.424 -0.585,7.623 0.148,3.502 0.741,5.545 1.808,7.063 C -4.421,1.619 -1.759,2.146 0,0 m -8.834,7.67 c -2.115,-3.573 -2.937,-10.262 -2.937,-15.397 0,-7.139 0.485,-11.787 1.152,-15.695 l 25.47,0 0,8.775 -9.331,0 c 0.453,2.713 0.716,6.112 0.694,9.053 C 6.153,1.586 4.466,6.922 1.822,9.351 -1.94,12.812 -6.483,11.65 -8.834,7.67"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSharp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sharp.39b2e70449be978d211e0a6f13f82767.svg";